import { BigNumber } from '@ethersproject/bignumber'
import { JSBI, Percent, Token, WETH as UWETH, ETHER, Currency } from '@uniswap/sdk'
import { AbstractConnector } from '@web3-react/abstract-connector'
import { ChainId } from './chainId';
import { fortmatic, injected, portis, walletconnect, walletlink } from '../connectors'

//@ts-ignore
export const getGaslimitCount = (chainid: ChainId): BigNumber => BigNumber.from(chainid === 137 ? 20 : 12)

//export const ROUTER_ADDRESS = '0x38A436197D523efAd879BdBbaE6B918021bC9D74'
export const ROUTER_ADDRESS = '0x13CE3345fC76f9F4f64c7df7cCaf55AffA4C1F17'

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

export { PRELOADED_PROPOSALS } from './proposals'

// a list of tokens by chain
type ChainTokenList = {
  readonly [chainId in ChainId]: Token[]
}

type ApiURLList = {
  readonly [chainId in ChainId]: string
}

export const WETH = {
  ...UWETH,
  [ChainId.MAINNET]: new Token(ChainId.MAINNET, '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', 18, 'WETH', 'Wrapped ETH'),
  [ChainId.POLYGON]: new Token(ChainId.POLYGON, '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619', 18, 'WETH', 'Wrapped ETH'),
  [ChainId.BASE]: new Token(ChainId.BASE, '0x4200000000000000000000000000000000000006', 18, 'WETH', 'Wrapped ETH'),
  [ChainId.BASE_GOERLI]: new Token(ChainId.BASE_GOERLI, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'WETH', 'Wrapped ETH'),
  [ChainId.PZT]: new Token(ChainId.PZT, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'WETH', 'Wrapped ETH'),
  [ChainId.PZ]: new Token(ChainId.PZ, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'WETH', 'Wrapped ETH'),
  [ChainId.ZKSYNC]: new Token(ChainId.ZKSYNC, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18,  'WETH', 'Wrapped ETH'),
  [ChainId.ZKSYNC_TEST]: new Token(ChainId.ZKSYNC_TEST, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18,  'WETH', 'Wrapped ETH'),
  [ChainId.TAIKO]: new Token(ChainId.TAIKO, '0xA51894664A773981C6C112C43ce576f315d5b1B6', 18, 'WETH', 'Wrapped ETH'),
  [ChainId.BLAST_SEPOLIA]: new Token(ChainId.BLAST_SEPOLIA, '0x7D40C46CaD2C6Ade6440008f74dFb66b3FC947E4', 18, 'WETH', 'Wrapped ETH')
}

export const WMATIC: { [chainId in ChainId]: Token } = {
  [ChainId.PZ]: new Token(ChainId.PZ, '0x90336b0C3f80F1eD297D5A9aBD896070fCdAE54b', 18, 'WMATIC', 'Wrapped MATIC'),
  [ChainId.PZT]: new Token(ChainId.PZT, '0x90336b0C3f80F1eD297D5A9aBD896070fCdAE54b', 18, 'WMATIC', 'Wrapped MATIC'),
  [ChainId.BASE]: new Token(ChainId.BASE, '0x90336b0C3f80F1eD297D5A9aBD896070fCdAE54b', 18, 'WMATIC', 'Wrapped MATIC'),
  [ChainId.BASE_GOERLI]: new Token(ChainId.BASE_GOERLI, '0x90336b0C3f80F1eD297D5A9aBD896070fCdAE54b', 18, 'WMATIC', 'Wrapped MATIC'),
  [ChainId.POLYGON]: new Token(ChainId.POLYGON, '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270', 18, 'WMATIC', 'Wrapped MATIC'),
  [ChainId.MAINNET]: new Token(ChainId.MAINNET, '0x90336b0C3f80F1eD297D5A9aBD896070fCdAE54b', 18, 'WMATIC', 'Wrapped MATIC'),
  [ChainId.RINKEBY]: new Token(ChainId.RINKEBY, '0x90336b0C3f80F1eD297D5A9aBD896070fCdAE54b', 18, 'WMATIC', 'Wrapped MATIC'),
  [ChainId.ROPSTEN]: new Token(ChainId.ROPSTEN, '0x90336b0C3f80F1eD297D5A9aBD896070fCdAE54b', 18, 'WMATIC', 'Wrapped MATIC'),
  [ChainId.GÖRLI]: new Token(ChainId.GÖRLI, '0x90336b0C3f80F1eD297D5A9aBD896070fCdAE54b', 18, 'WMATIC', 'Wrapped MATIC'),
  [ChainId.KOVAN]: new Token(ChainId.KOVAN, '0x90336b0C3f80F1eD297D5A9aBD896070fCdAE54b', 18, 'WMATIC', 'Wrapped MATIC'),
  [ChainId.ZKSYNC]: new Token(ChainId.ZKSYNC, '0x90336b0C3f80F1eD297D5A9aBD896070fCdAE54b', 18, 'WMATIC', 'Wrapped MATIC'),
  [ChainId.ZKSYNC_TEST]: new Token(ChainId.ZKSYNC_TEST, '0x90336b0C3f80F1eD297D5A9aBD896070fCdAE54b', 18, 'WMATIC', 'Wrapped MATIC'),
  [ChainId.TAIKO]: new Token(ChainId.ZKSYNC_TEST, '0x90336b0C3f80F1eD297D5A9aBD896070fCdAE54b', 18, 'WMATIC', 'Wrapped MATIC'),
  [ChainId.BLAST_SEPOLIA]: new Token(ChainId.BLAST_SEPOLIA, '0x90336b0C3f80F1eD297D5A9aBD896070fCdAE54b', 18, 'WMATIC', 'Wrapped MATIC'),
}

export const RAI = {
  1442: new Token(ChainId.MAINNET, '0xF0e75317D2F54d4a93E8A04c72B5AD1Efb8ED9ee', 18, 'RAI', 'RAI Finance'),
  1: new Token(ChainId.MAINNET, '0xF0e75317D2F54d4a93E8A04c72B5AD1Efb8ED9ee', 18, 'RAI', 'RAI Finance'),
  4: new Token(ChainId.RINKEBY, '0xF0e75317D2F54d4a93E8A04c72B5AD1Efb8ED9ee', 18, 'RAI', 'RAI Finance'),
  [ChainId.ROPSTEN]: new Token(ChainId.ROPSTEN, '0xF0e75317D2F54d4a93E8A04c72B5AD1Efb8ED9ee', 18, 'RAI', 'RAI Finance'),
  [ChainId.GÖRLI]: new Token(ChainId.GÖRLI, '0xF0e75317D2F54d4a93E8A04c72B5AD1Efb8ED9ee', 18, 'RAI', 'RAI Finance'),
  [ChainId.KOVAN]: new Token(ChainId.KOVAN, '0xF0e75317D2F54d4a93E8A04c72B5AD1Efb8ED9ee', 18, 'RAI', 'RAI Finance'),
}

export const USDR = {
  1: new Token(ChainId.MAINNET, '0x6539aa1C0652aF2fC10a5c0fEF4f3D8fA44Ef6Dd', 6, 'USDT', 'RAI USDT'),
  4: new Token(ChainId.RINKEBY, '0x6539aa1C0652aF2fC10a5c0fEF4f3D8fA44Ef6Dd', 6, 'USDT', 'RAI USDT'),
}

export const DAI = new Token(ChainId.MAINNET, '0x6B175474E89094C44Da98b954EedeAC495271d0F', 18, 'DAI', 'Dai Stablecoin')
export const USDC = new Token(ChainId.MAINNET, '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', 6, 'USDC', 'USDC')
export const USDT = new Token(ChainId.MAINNET, '0xdAC17F958D2ee523a2206206994597C13D831ec7', 6, 'USDT', 'Tether USD')
export const WBTC = new Token(ChainId.MAINNET, '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599', 8, 'WBTC', 'Wrapped BTC')
export const FEI = new Token(ChainId.MAINNET, '0x956F47F50A910163D8BF957Cf5846D573E7f87CA', 18, 'FEI', 'Fei USD')
export const TRIBE = new Token(ChainId.MAINNET, '0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B', 18, 'TRIBE', 'Tribe')
export const FRAX = new Token(ChainId.MAINNET, '0x853d955aCEf822Db058eb8505911ED77F175b99e', 18, 'FRAX', 'Frax')
export const FXS = new Token(ChainId.MAINNET, '0x3432B6A60D23Ca0dFCa7761B7ab56459D9C964D0', 18, 'FXS', 'Frax Share')
export const renBTC = new Token(ChainId.MAINNET, '0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D', 8, 'renBTC', 'renBTC')
// export const TUSDT = new Token(ChainId.RINKEBY, '0xB7A70A06bC6123445d52Fcd1D91553141F1d89F2', 18, "USDT", "Tether USD")

export const TEST = new Token(ChainId.RINKEBY, '0xE21A72A93A475cD835919FbDc0478f567B3Cd4ed', 10, 'CERE', 'CERE')

export const TBTC = {
  [ChainId.PZ]: new Token(ChainId.PZ, '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6', 18, 'BTC', 'Bitcoin'),
  [ChainId.PZT]: new Token(ChainId.PZT, '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6', 18, 'BTC', 'Bitcoin'),
  [ChainId.BASE_GOERLI]: new Token(ChainId.BASE_GOERLI, '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6', 18, 'BTC', 'Bitcoin'),
  [ChainId.POLYGON]: new Token(ChainId.POLYGON, '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6', 18, 'BTC', 'Bitcoin'),
  [ChainId.MAINNET]: new Token(ChainId.RINKEBY, '0x6A2eDf35279FB398Abc8BE5CC8eD007d64726fc7', 18, 'BTC', 'Bitcoin'),
  [ChainId.RINKEBY]: new Token(ChainId.RINKEBY, '0x7039DF59Aed9b72157F812e012727d620546573f', 18, 'BTC', 'Bitcoin'),
  [ChainId.ROPSTEN]: new Token(ChainId.RINKEBY, '0x6A2eDf35279FB398Abc8BE5CC8eD007d64726fc7', 18, 'BTC', 'Bitcoin'),
  [ChainId.GÖRLI]: new Token(ChainId.RINKEBY, '0x6A2eDf35279FB398Abc8BE5CC8eD007d64726fc7', 18, 'BTC', 'Bitcoin'),
  [ChainId.KOVAN]: new Token(ChainId.RINKEBY, '0x6A2eDf35279FB398Abc8BE5CC8eD007d64726fc7', 18, 'BTC', 'Bitcoin'),
  [ChainId.ZKSYNC]: new Token(ChainId.ZKSYNC, '0x6A2eDf35279FB398Abc8BE5CC8eD007d64726fc7', 18, 'BTC', 'Bitcoin'),
  [ChainId.ZKSYNC_TEST]: new Token(ChainId.ZKSYNC_TEST, '0x6A2eDf35279FB398Abc8BE5CC8eD007d64726fc7', 18, 'BTC', 'Bitcoin'),
  [ChainId.TAIKO]: new Token(ChainId.TAIKO, '0x6A2eDf35279FB398Abc8BE5CC8eD007d64726fc7', 18, 'BTC', 'Bitcoin'),
}

export const TRAI = {
  [ChainId.PZ]: new Token(ChainId.PZ, '0x706fcE1cb1bB0818D81D5A717E2cCF5c0e4D43E1', 18, 'RAI', 'RAI FINANCE'),
  [ChainId.PZT]: new Token(ChainId.PZT, '0x706fcE1cb1bB0818D81D5A717E2cCF5c0e4D43E1', 18, 'RAI', 'RAI FINANCE'),
  [ChainId.BASE]: new Token(ChainId.BASE_GOERLI, '0x706fcE1cb1bB0818D81D5A717E2cCF5c0e4D43E1', 18, 'RAI', 'RAI FINANCE'),
  [ChainId.BASE_GOERLI]: new Token(ChainId.BASE_GOERLI, '0x706fcE1cb1bB0818D81D5A717E2cCF5c0e4D43E1', 18, 'RAI', 'RAI FINANCE'),
  [ChainId.POLYGON]: new Token(ChainId.POLYGON, '0x706fcE1cb1bB0818D81D5A717E2cCF5c0e4D43E1', 18, 'RAI', 'RAI FINANCE'),
  [ChainId.KOVAN]: new Token(ChainId.RINKEBY, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'RAI', 'RAI FINANCE'),
  [ChainId.GÖRLI]: new Token(ChainId.RINKEBY, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'RAI', 'RAI FINANCE'),
  [ChainId.ROPSTEN]: new Token(ChainId.RINKEBY, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'RAI', 'RAI FINANCE'),
  [ChainId.RINKEBY]: new Token(ChainId.RINKEBY, '0x706fcE1cb1bB0818D81D5A717E2cCF5c0e4D43E1', 18, 'RAI', 'RAI FINANCE'),
  [ChainId.MAINNET]: new Token(ChainId.RINKEBY, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'RAI', 'RAI FINANCE'),
  [ChainId.ZKSYNC]: new Token(ChainId.ZKSYNC, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'RAI', 'RAI FINANCE'),
  [ChainId.ZKSYNC_TEST]: new Token(ChainId.ZKSYNC_TEST, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'RAI', 'RAI FINANCE'),
  [ChainId.TAIKO]: new Token(ChainId.TAIKO, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'RAI', 'RAI FINANCE'),
  [ChainId.BLAST_SEPOLIA]: new Token(ChainId.BLAST_SEPOLIA, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'RAI', 'RAI FINANCE'),
}

export const TSOFI = {
  [ChainId.PZ]: new Token(ChainId.PZ, '0x8cAba8e4Ed03C416f024376B095Ce5Be3560Ab60', 18, 'SOFI', 'SOFI SOFI'),
  [ChainId.PZT]: new Token(ChainId.PZT, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'SOFI', 'SOFI SOFI'),
  [ChainId.BASE]: new Token(ChainId.BASE, '0x703D57164CA270b0B330A87FD159CfEF1490c0a5', 18, 'SOFI', 'SOFI SOFI'),
  [ChainId.BASE_GOERLI]: new Token(ChainId.BASE_GOERLI, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'SOFI', 'SOFI SOFI'),
  [ChainId.POLYGON]: new Token(ChainId.POLYGON, '0x7cb810ecBFd6125E65f451cFBd8Ae657dFFDd6b4', 18, 'SOFI', 'SOFI SOFI'),
  [ChainId.KOVAN]: new Token(ChainId.KOVAN, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'SOFI', 'SOFI SOFI'),
  [ChainId.GÖRLI]: new Token(ChainId.GÖRLI, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'SOFI', 'SOFI SOFI'),
  [ChainId.ROPSTEN]: new Token(ChainId.ROPSTEN, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'SOFI', 'SOFI SOFI'),
  [ChainId.RINKEBY]: new Token(ChainId.RINKEBY, '0xb5781d40827625e28da52e688432474146c74a40', 18, 'SOFI', 'SOFI SOFI'),
  [ChainId.MAINNET]: new Token(ChainId.MAINNET, '0xB49fa25978abf9a248b8212Ab4b87277682301c0', 18, 'SOFI', 'SOFI SOFI'),
  [ChainId.ZKSYNC]: new Token(ChainId.ZKSYNC, '0xB49fa25978abf9a248b8212Ab4b87277682301c0', 18, 'SOFI', 'SOFI SOFI'),
  [ChainId.ZKSYNC_TEST]: new Token(ChainId.ZKSYNC_TEST, '0xB49fa25978abf9a248b8212Ab4b87277682301c0', 18, 'SOFI', 'SOFI SOFI'),
  [ChainId.TAIKO]: new Token(ChainId.TAIKO, '0xB49fa25978abf9a248b8212Ab4b87277682301c0', 18, 'SOFI', 'SOFI SOFI'),
  [ChainId.BLAST_SEPOLIA]: new Token(ChainId.BLAST_SEPOLIA, '0x12BF894c47D9246e92F58d6AE22E1A32fd6D306E', 18, 'SOFI', 'SOFI SOFI'),
}

export const TUSDT: { [chainId in ChainId]: Token } = {
  [ChainId.PZ]: new Token(ChainId.PZ, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'USDT', 'Tether USD'),
  [ChainId.PZT]: new Token(ChainId.PZT, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18,  'USDT', 'Tether USD'),
  [ChainId.BASE]: new Token(ChainId.BASE, '0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA', 18,  'USDbC', 'USDbC'),
  [ChainId.BASE_GOERLI]: new Token(ChainId.BASE_GOERLI, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18,  'USDT', 'Tether USD'),
  [ChainId.POLYGON]: new Token(ChainId.POLYGON, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18,  'USDT', 'Tether USD'),
  [ChainId.KOVAN]: new Token(ChainId.KOVAN, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'USDT', 'Tether USD'),
  [ChainId.GÖRLI]: new Token(ChainId.GÖRLI, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'USDT', 'Tether USD'),
  [ChainId.ROPSTEN]: new Token(ChainId.ROPSTEN, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'USDT', 'Tether USD'),
  [ChainId.RINKEBY]: new Token(ChainId.RINKEBY, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'USDT', 'Tether USD'),
  [ChainId.MAINNET]: new Token(ChainId.MAINNET, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'USDT', 'Tether USD'),
  [ChainId.ZKSYNC]: new Token(ChainId.ZKSYNC, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18,'USDT', 'Tether USD'),
  [ChainId.ZKSYNC_TEST]: new Token(ChainId.ZKSYNC_TEST, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18,'USDT', 'Tether USD'),
  [ChainId.TAIKO]: new Token(ChainId.TAIKO, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'USDT', 'Tether USD'),
  [ChainId.BLAST_SEPOLIA]: new Token(ChainId.BLAST_SEPOLIA, '0x4FA214C9e33D481996bEc77C443245fBAeE85670', 18, 'USDT', 'Tether USD'),
}
// Block time here is slightly higher (~1s) than average in order to avoid ongoing proposals past the displayed time
export const AVERAGE_BLOCK_TIME_IN_SECS = 13
export const PROPOSAL_LENGTH_IN_BLOCKS = 40_320
export const PROPOSAL_LENGTH_IN_SECS = AVERAGE_BLOCK_TIME_IN_SECS * PROPOSAL_LENGTH_IN_BLOCKS

export const GOVERNANCE_ADDRESS = '0x5e4be8Bc9637f0EAA1A755019e06A68ce081D58F'

export const TIMELOCK_ADDRESS = '0x1a9C8182C09F50C8318d769245beA52c32BE35BC'
export const DEFAULT_API_URL = process.env.REACT_APP_API_URL || 'https://api.rai.finance'

export const APR_URL = process.env.REACT_APP_API_URL || 'https://api.rai.finance'

const UNI_ADDRESS = '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984'
export const UNI: { [chainId in ChainId]: Token } = {
  [ChainId.PZ]: new Token(ChainId.PZ, UNI_ADDRESS, 18,  'UNI', 'Uniswap'),
  [ChainId.PZT]: new Token(ChainId.PZT, UNI_ADDRESS, 18,   'UNI', 'Uniswap'),
  [ChainId.BASE]: new Token(ChainId.BASE, UNI_ADDRESS, 18,   'UNI', 'Uniswap'),
  [ChainId.BASE_GOERLI]: new Token(ChainId.BASE_GOERLI, UNI_ADDRESS, 18,   'UNI', 'Uniswap'),
  [ChainId.POLYGON]: new Token(ChainId.POLYGON, UNI_ADDRESS, 18,   'UNI', 'Uniswap'),
  [ChainId.KOVAN]: new Token(ChainId.KOVAN, UNI_ADDRESS, 18,  'UNI', 'Uniswap'),
  [ChainId.GÖRLI]: new Token(ChainId.GÖRLI, UNI_ADDRESS, 18,  'UNI', 'Uniswap'),
  [ChainId.ROPSTEN]: new Token(ChainId.ROPSTEN, UNI_ADDRESS, 18,  'UNI', 'Uniswap'),
  [ChainId.RINKEBY]: new Token(ChainId.RINKEBY, UNI_ADDRESS, 18,  'UNI', 'Uniswap'),
  [ChainId.MAINNET]: new Token(ChainId.MAINNET, UNI_ADDRESS, 18,  'UNI', 'Uniswap'),
  [ChainId.ZKSYNC]: new Token(ChainId.ZKSYNC, UNI_ADDRESS, 18, 'UNI', 'Uniswap'),
  [ChainId.ZKSYNC_TEST]: new Token(ChainId.ZKSYNC_TEST, UNI_ADDRESS, 18, 'UNI', 'Uniswap'),
  [ChainId.TAIKO]: new Token(ChainId.TAIKO, UNI_ADDRESS, 18, 'UNI', 'Uniswap'),
  [ChainId.BLAST_SEPOLIA]: new Token(ChainId.BLAST_SEPOLIA, UNI_ADDRESS, 18, 'UNI', 'Uniswap'),
}

export const COMMON_CONTRACT_NAMES: { [address: string]: string } = {
  [UNI_ADDRESS]: 'UNI',
  [GOVERNANCE_ADDRESS]: 'Governance',
  [TIMELOCK_ADDRESS]: 'Timelock'
}

// TODO: specify merkle distributor for mainnet
export const MERKLE_DISTRIBUTOR_ADDRESS: { [chainId in ChainId]?: string } = {
  [ChainId.MAINNET]: '0x090D4613473dEE047c3f2706764f49E0821D256e'
}

const WETH_ONLY: ChainTokenList = {
  [ChainId.PZ]: [WETH[ChainId.PZ]],
  [ChainId.PZT]:[WETH[ChainId.PZT]],
  [ChainId.BASE]: [WETH[ChainId.BASE]],
  [ChainId.BASE_GOERLI]: [WETH[ChainId.BASE_GOERLI]],
  [ChainId.POLYGON]: [WETH[ChainId.POLYGON]],
  [ChainId.MAINNET]: [WETH[ChainId.MAINNET]],
  [ChainId.ROPSTEN]: [WETH[ChainId.ROPSTEN]],
  [ChainId.RINKEBY]: [WETH[ChainId.RINKEBY]],
  [ChainId.GÖRLI]: [WETH[ChainId.GÖRLI]],
  [ChainId.KOVAN]: [WETH[ChainId.KOVAN]],
  [ChainId.ZKSYNC]: [WETH[ChainId.ZKSYNC]],
  [ChainId.ZKSYNC_TEST]: [WETH[ChainId.ZKSYNC_TEST]],
  [ChainId.TAIKO]: [WETH[ChainId.TAIKO]],
  [ChainId.BLAST_SEPOLIA]: [WETH[ChainId.BLAST_SEPOLIA]]
}

// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  ...WETH_ONLY,
  [ChainId.MAINNET]: [...WETH_ONLY[ChainId.MAINNET], DAI, USDC, USDT, WBTC]
}

export const APILIST: ApiURLList = {
  [ChainId.MAINNET]: DEFAULT_API_URL + '/eth',
  [ChainId.ROPSTEN]: DEFAULT_API_URL,
  [ChainId.RINKEBY]: DEFAULT_API_URL + '/rinkeby',
  [ChainId.GÖRLI]: DEFAULT_API_URL,
  [ChainId.KOVAN]: DEFAULT_API_URL,
  [ChainId.POLYGON]: DEFAULT_API_URL + '/matic',
  [ChainId.BASE]: DEFAULT_API_URL + '/base',
  [ChainId.BASE_GOERLI]: DEFAULT_API_URL + '/base-goerli',
  [ChainId.PZT]: DEFAULT_API_URL + '/pzt',
  [ChainId.PZ]: DEFAULT_API_URL + '/pz',
  [ChainId.ZKSYNC]:  DEFAULT_API_URL + '/zksync',
  [ChainId.ZKSYNC_TEST]: DEFAULT_API_URL + '/zktest',
  [ChainId.TAIKO]: DEFAULT_API_URL+ '/taiko',
  [ChainId.BLAST_SEPOLIA]: DEFAULT_API_URL+ '/blast',
}

export const APR_API_LIST: ApiURLList = {
  [ChainId.MAINNET]: APR_URL + '/rinkeby',
  [ChainId.ROPSTEN]: APR_URL,
  [ChainId.RINKEBY]: APR_URL + '/rinkeby',
  [ChainId.GÖRLI]: APR_URL,
  [ChainId.KOVAN]: APR_URL,
  [ChainId.POLYGON]: APR_URL,
  [ChainId.BASE]: APR_URL,
  [ChainId.BASE_GOERLI]: APR_URL,
  [ChainId.PZT]: APR_URL,
  [ChainId.PZ]: APR_URL,
  [ChainId.ZKSYNC]:  APR_URL,
  [ChainId.ZKSYNC_TEST]: APR_URL,
  [ChainId.TAIKO]: APR_URL,
  [ChainId.BLAST_SEPOLIA]: APR_URL,
}

/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 */
export const CUSTOM_BASES: { [chainId in ChainId]?: { [tokenAddress: string]: Token[] } } = {
}

// used for display in the default list when adding liquidity
export const SUGGESTED_BASES: ChainTokenList = {
  ...WETH_ONLY,
  [ChainId.MAINNET]: [...WETH_ONLY[ChainId.MAINNET], DAI, USDC, USDT, WBTC]
}
export const GAS_TOKEN: { [chainId in ChainId]: string[] }  = {
  [ChainId.MAINNET]: ['ETH'],
  [ChainId.ROPSTEN]:  ['ETH'],
  [ChainId.RINKEBY]: ['ETH'],
  [ChainId.GÖRLI]:  ['ETH'],
  [ChainId.KOVAN]:  ['ETH'],
  [ChainId.POLYGON]: ['MATIC'],
  [ChainId.BASE]: ['USDbC','ETH'],
  [ChainId.BASE_GOERLI]:  ['ETH'],
  [ChainId.PZT]: ['ETH'],
  [ChainId.PZ]: ['ETH'],
  [ChainId.ZKSYNC]:  ['ETH'],
  [ChainId.ZKSYNC_TEST]: ['ETH'],
  [ChainId.TAIKO]: ['ETH'],
  [ChainId.BLAST_SEPOLIA]:  ['ETH'],
}

// used to construct the list of all pairs we consider by default in the frontend
export const BASES_TO_TRACK_LIQUIDITY_FOR: ChainTokenList = {
  ...WETH_ONLY,
  [ChainId.MAINNET]: [...WETH_ONLY[ChainId.MAINNET], DAI, USDC, USDT, WBTC]
}

export const PINNED_PAIRS: { readonly [chainId in ChainId]?: [Token, Token][] } = {
  [ChainId.MAINNET]: [
    [
      new Token(ChainId.MAINNET, '0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643', 8, 'cDAI', 'Compound Dai'),
      new Token(ChainId.MAINNET, '0x39AA39c021dfbaE8faC545936693aC917d5E7563', 8, 'cUSDC', 'Compound USD Coin')
    ],
    [USDC, USDT],
    [DAI, USDT]
  ]
}

export interface WalletInfo {
  connector?: AbstractConnector
  name: string
  iconName: string
  description: string
  href: string | null
  color: string
  primary?: true
  mobile?: true
  mobileOnly?: true
}

export const SUPPORTED_WALLETS: { [key: string]: WalletInfo } = {
  // INJECTED: {
  //   connector: injected,
  //   name: 'Injected',
  //   iconName: 'arrow-right.svg',
  //   description: 'Injected web3 provider.',
  //   href: null,
  //   color: '#010101',
  //   primary: true
  // },
  METAMASK: {
    connector: injected,
    name: 'MetaMask',
    iconName: 'metamask.png',
    description: 'Easy-to-use browser extension.',
    href: null,
    color: '#E8831D'
  },
  // WALLET_CONNECT: {
  //   connector: walletconnect,
  //   name: 'WalletConnect',
  //   iconName: 'walletConnectIcon.svg',
  //   description: 'Connect to Trust Wallet, Rainbow Wallet and more...',
  //   href: null,
  //   color: '#4196FC',
  //   mobile: true
  // },
  // WALLET_LINK: {
  //   connector: walletlink,
  //   name: 'Coinbase Wallet',
  //   iconName: 'coinbaseWalletIcon.svg',
  //   description: 'Use Coinbase Wallet app on mobile device',
  //   href: null,
  //   color: '#315CF5'
  // },
  WALLET_LINK: {
    connector: walletlink,
    name: 'Coinbase Wallet',
    iconName: 'coinbaseWalletIcon.svg',
    description: 'Use Coinbase Wallet app on mobile device',
    href: null,
    color: '#315CF5'
  }
  // FORTMATIC: {
  //   connector: fortmatic,
  //   name: 'Fortmatic',
  //   iconName: 'fortmaticIcon.png',
  //   description: 'Login using Fortmatic hosted wallet',
  //   href: null,
  //   color: '#6748FF',
  //   mobile: true
  // },
  // Portis: {
  //   connector: portis,
  //   name: 'Portis',
  //   iconName: 'portisIcon.png',
  //   description: 'Login using Portis hosted wallet',
  //   href: null,
  //   color: '#4A6C9B',
  //   mobile: true
  // }
}

export const NetworkContextName = 'NETWORK'

// default allowed slippage, in bips
export const INITIAL_ALLOWED_SLIPPAGE = 50
// 20 minutes, denominated in seconds
export const DEFAULT_DEADLINE_FROM_NOW = 60 * 20

// used for rewards deadlines
export const BIG_INT_SECONDS_IN_WEEK = JSBI.BigInt(60 * 60 * 24 * 7)

export const BIG_INT_ZERO = JSBI.BigInt(0)

// one basis point
export const ONE_BIPS = new Percent(JSBI.BigInt(1), JSBI.BigInt(10000))
export const BIPS_BASE = JSBI.BigInt(10000)
// used for warning states
export const ALLOWED_PRICE_IMPACT_LOW: Percent = new Percent(JSBI.BigInt(100), BIPS_BASE) // 1%
export const ALLOWED_PRICE_IMPACT_MEDIUM: Percent = new Percent(JSBI.BigInt(300), BIPS_BASE) // 3%
export const ALLOWED_PRICE_IMPACT_HIGH: Percent = new Percent(JSBI.BigInt(500), BIPS_BASE) // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
export const PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN: Percent = new Percent(JSBI.BigInt(1000), BIPS_BASE) // 10%
// for non expert mode disable swaps above this
export const BLOCKED_PRICE_IMPACT_NON_EXPERT: Percent = new Percent(JSBI.BigInt(1500), BIPS_BASE) // 15%

// used to ensure the user doesn't send so much ETH so they end up with <.01
export const MIN_ETH: JSBI = JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(16)) // .01 ETH
export const BETTER_TRADE_LESS_HOPS_THRESHOLD = new Percent(JSBI.BigInt(50), JSBI.BigInt(10000))

export const ZERO_PERCENT = new Percent('0')
export const ONE_HUNDRED_PERCENT = new Percent('1')
export const FACTORY_ADDRESS = '0xC6e0Eeb5E45857BB2ca38ef8C139ED1bBeFFB837'

// SDN OFAC addresses
export const BLOCKED_ADDRESSES: string[] = [
  '0x7F367cC41522cE07553e823bf3be79A889DEbe1B',
  '0xd882cFc20F52f2599D84b8e8D58C7FB62cfE344b',
  '0x901bb9583b24D97e995513C6778dc6888AB6870e',
  '0xA7e5d5A720f06526557c513402f2e6B5fA20b008',
  '0x8576aCC5C05D6Ce88f4e49bf65BdF0C62F91353C'
]

export const ProtocolViewer_Address: { [chainId in ChainId]?: string } = {
  [ChainId.MAINNET]: '0x6A9c7d126d17c35785d06D9AE17f6215ffE425e9',
  [ChainId.RINKEBY]: '0x6531927903C73942af0484717503b763F0021eA3'
}

export const portfolioFactory: { [chainId in ChainId]?: string } = {
  [ChainId.PZT]: '0xaB049175cBA373Cdf038e5bef7746B4403717220',
  [ChainId.BASE]: '0xBC097E42BF1E6531C32C5cEe945E0c014fA21964',
  [ChainId.BASE_GOERLI]: '0xaB049175cBA373Cdf038e5bef7746B4403717220',
  [ChainId.MAINNET]: '0x12BF894c47D9246e92F58d6AE22E1A32fd6D306E',
  [ChainId.POLYGON]: '0x12BF894c47D9246e92F58d6AE22E1A32fd6D306E',
  [ChainId.RINKEBY]: '0xD22761d8362a0e28466CD5E526Be4Fa69EadfdCD',
  [ChainId.TAIKO]: '0xcD206e0C843b72B39D20efE28B8190c4E142b862',
  [ChainId.BLAST_SEPOLIA]: '0x84B80DeAF0fae24DB776C5839a64c1b4496Ea6d5',
}

export const portfolioModule: { [chainId in ChainId]?: string } = {
  [ChainId.PZT]: '0xcD206e0C843b72B39D20efE28B8190c4E142b862',
  [ChainId.BASE]: '0x1e6Dbd0E827cd243d458ed73B9Ae1a6Db89B8668',
  [ChainId.BASE_GOERLI]: '0xcD206e0C843b72B39D20efE28B8190c4E142b862',
  [ChainId.MAINNET]: '0x6ca55AB2627736A19D9d481171354e3630a442Cc',
  [ChainId.POLYGON]: '0x6ca55AB2627736A19D9d481171354e3630a442Cc',
  [ChainId.RINKEBY]: '0x5aF22A32E90aa8195cf15a0675225e46CFb30EE5',
  [ChainId.TAIKO]: '0xDEDaaE2ACF3ab0cD7754d5aB26b317e52B02c8cd',
  [ChainId.BLAST_SEPOLIA]: '0xD55a4d54f39baF26da2F3EE7bE9a6388c15F9831',
}

export const managerModule: { [chainId in ChainId]?: string } = {
  [ChainId.PZT]: '0x4a5e04B1e9DD4faA3057EcA8076a70D985873C6a',
  [ChainId.BASE]: '0x4E69553b0aEf0949Fd38Bbf3EbeD866B431C9E68',
  [ChainId.BASE_GOERLI]: '0x4a5e04B1e9DD4faA3057EcA8076a70D985873C6a',
  [ChainId.MAINNET]: '0xcD206e0C843b72B39D20efE28B8190c4E142b862',
  [ChainId.POLYGON]: '0x8CB3b74d7F6F0C1b97A4E25628c9440FD3Cd87e9',
  [ChainId.RINKEBY]: '0x6A09a4B80c40D13dBD97D0d366f650dEd3aD724C',
  [ChainId.TAIKO]: '0xe9809d71259fcCB94447a1449d3989d4A6c28927',
  [ChainId.BLAST_SEPOLIA]: '0x6A9c7d126d17c35785d06D9AE17f6215ffE425e9',
}

export const trading: { [chainId in ChainId]?: string } = {
  [ChainId.PZT]: '0xD55a4d54f39baF26da2F3EE7bE9a6388c15F9831',
  [ChainId.BASE]: '0x73Ada4aE37Ba1DF45Ba12c4478a27029e24cF2d7',
  [ChainId.BASE_GOERLI]: '0xD55a4d54f39baF26da2F3EE7bE9a6388c15F9831',
  [ChainId.MAINNET]: '0x3b309aC86d6B1D8e82AA2bDAce455eD5C7138A8F',
  [ChainId.POLYGON]: '0x681B1D23BFe0d3A6E44E625EA73DcA8C05e18aCD',
  [ChainId.RINKEBY]: '0x53B6a4f9845D23493d4c14561F35d2af659BF26E',
  [ChainId.TAIKO]: '0x8e7DB24eB395BD2965E0701b364ACdB67b9Dea8f',
  [ChainId.BLAST_SEPOLIA]: '0x10e9cB84C2002392412A627D12d4F3dF4568246c',
}

export const RAIProxy_contract_address: { [chainId in ChainId]?: string } = {
  [ChainId.PZT]: '0x19e9338be738c7e51b2126A5e7B6A4c1ecB03DC2',
  [ChainId.BASE]: '0x53BAE026d9a503d46a58aF4b65FCcbb7B904A911',
  [ChainId.BASE_GOERLI]: '0x19e9338be738c7e51b2126A5e7B6A4c1ecB03DC2',
  [ChainId.MAINNET]: '0x7523F40296F963992A0166dBa7A46d9237ACD666',
  [ChainId.POLYGON]: '0x5A3F6bBBb0777bd0cF24eA502F144311528e13b1',
  [ChainId.RINKEBY]: '0xE677e62dAB9a8984138EAaf4c47ac9FC148Aa5C5',
  [ChainId.ZKSYNC_TEST]: '0x5c9b7aBBbf5c060CEc0C1dd11DE6F50671CbE78B',
  [ChainId.TAIKO]: '0xcdCe9e57CB1cA1e7EA129bC211e8F3741C4dC898',
  [ChainId.BLAST_SEPOLIA]: '0xcD206e0C843b72B39D20efE28B8190c4E142b862',
}

export const SOFI_DAO_contract_address: { [chainId in ChainId]?: string } = {
  [ChainId.MAINNET]: '0xFFBd847806Cc462b1Df726C5363E8D40f52afa8f',
  [ChainId.RINKEBY]: '0x2c60b369417c5EEe02D519a6644E5Ca0c468C0A4',
  [ChainId.BASE]: '0xa047AE27b6785a1Dceb75d85222E33CB3519F239',
}

export const SOFI_Promote_contract_address: { [chainId in ChainId]?: string } = {
  [ChainId.MAINNET]: '0xFb96193381E55600A530F5a49fD678F9A4CB9585',
  [ChainId.POLYGON]: '0xcac07e52D41d416aD52aAf051aca95e20B8Dd58E',
  [ChainId.RINKEBY]: '0xF10b7F1301dB5f810b936c25D7018c6f9dB34c5e',
}

export const NETWORK_LABELS: { [chainId in ChainId]?: string } = {
  [ChainId.MAINNET]: 'Ethereum',
  [ChainId.RINKEBY]: 'Rinkeby',
  [ChainId.ROPSTEN]: 'Ropsten',
  [ChainId.GÖRLI]: 'Görli',
  [ChainId.KOVAN]: 'Kovan',
  [ChainId.POLYGON]: 'Polygon',
  [ChainId.TAIKO]: 'TAIKO',
  [ChainId.BASE]: 'Base Mainnet',
  [ChainId.BLAST_SEPOLIA]: 'Blast Sepolia'
}

export const SOFI_Predict_contract_address: { [chainId in ChainId]?: string } = {
  [ChainId.MAINNET]: '0xfc5f67c6395b4a1a42c5d7482471515d4efd8da8',
  [ChainId.POLYGON]: '0x47199e6fDd30168D0f1282f3B0e7c80c1268BB5c',
  [ChainId.RINKEBY]: '0xfc5f67c6395b4a1a42c5d7482471515d4efd8da8'
}

export const FixedProductMarketMaker_addresss: { [chainId in ChainId]?: string } = {
  [ChainId.MAINNET]: '0x1481419AD766f099104997b69d7BA973024ccF88',
  [ChainId.POLYGON]: '0xe7A1b04373E5e72675E3329999374fb4D5abe5Ac',
  [ChainId.RINKEBY]: '0x1481419AD766f099104997b69d7BA973024ccF88'
}

export interface BaseChain {
  id: number;
  name: string;
  tokenSymbol: string;
  token: any;
  wrappedTokenSymbol?: string;
  wrappedToken?: any;
  icon: string;
  scanUrl: string;
  scanName: string;
  vmType: string;
  rpcUrl: string;
  blockDelta?: number; // time for producing a new block
  blockDeltaU?: number; // time for producing a new block average
}

const baseURL = "https://rai-static.s3.ap-northeast-1.amazonaws.com/sts/token/"

const initialChains: BaseChain[] = [
  {
      id: ChainId.MAINNET,
      name: 'Ethereum',
      tokenSymbol: 'ETH',
      token: WETH[ChainId.MAINNET],
      wrappedTokenSymbol: 'WETH',
      wrappedToken: WETH[ChainId.MAINNET],
      icon: baseURL + 'eth.png',
      scanUrl: 'https://etherscan.io/',
      scanName: 'EtherScan',
      vmType: 'EVM',
      rpcUrl: 'https://mainnet.infura.io/v3/1d8efe3c81f6403fac6633ef69479a73',
  },
  {
      id: ChainId.POLYGON,
      name: 'Polygon',
      tokenSymbol: 'Matic',
      token: WMATIC[ChainId.POLYGON],
      wrappedTokenSymbol: 'WMATIC',
      wrappedToken: WMATIC[ChainId.POLYGON],
      icon: baseURL + 'matic.png',
      scanUrl: 'https://polygonscan.com/',
      scanName: 'PologonScan',
      vmType: 'EVM',
      rpcUrl: 'https://polygon-rpc.com/',
  },
  {
      id: ChainId.RINKEBY,
      name: 'Rinkeby',
      tokenSymbol: 'ETH',
      token: WETH[ChainId.RINKEBY],
      wrappedTokenSymbol: 'WETH',
      wrappedToken:  WETH[ChainId.RINKEBY],
      icon: baseURL + 'eth.png',
      scanUrl: 'https://rinkeby.etherscan.io/',
      scanName: 'EtherScan',
      vmType: 'EVM',
      rpcUrl: 'https://rinkeby.infura.io/v3/',
  },
  {
      id: ChainId.BASE,
      name: 'Base',
      tokenSymbol: 'ETH',
      token: WETH[ChainId.BASE],
      wrappedTokenSymbol: 'WETH',
      wrappedToken: WETH[ChainId.BASE],
      icon: baseURL + 'base.png',
      scanUrl: 'https://basescan.org/',
      scanName: 'base scan',
      vmType: 'EVM',
      rpcUrl: 'https://developer-access-mainnet.base.org',
  },{
    id: ChainId.TAIKO,
    name: 'Taiko',
    tokenSymbol: 'ETH',
    token: WETH[ChainId.TAIKO],
    wrappedTokenSymbol: 'WETH',
    wrappedToken: WETH[ChainId.TAIKO],
    icon: baseURL + 'eth.png',
    scanUrl: 'https://taikoscan.io/',
    scanName: 'TaikoScan',
    vmType: 'EVM',
    rpcUrl: 'https://rpc.taiko.xyz',
  }
];


export const getChain = (chainId: ChainId) => {
  return initialChains.find((chain) => {
      return chain.id === chainId;
  });
};